module.exports = __webpack_public_path__ + "assets/img/00126.7543eec3.png";